import React from 'react'
import Radio from '@mui/material/Radio'
import Link from '@mui/material/Link'
import * as S from './styles.js'

export function InvestmentSelect({ data, setData, openDialog }) {
	const onClick = (event) => {
		window.mixpanel.track("Rentability Dialog")
		event.preventDefault()
		openDialog()
	}

	return (<>
		<S.Text>Onde você costuma investir?</S.Text>
		<S.Control>
			<Radio
			name="investment"
			id="investment-1"
			checked={data.investment === 'Conservador'}
			onChange={(e) => {
				setData({
					...data,
					investment: e.target.value
				})
			}}
			value="Conservador"
			inputProps={{ 'aria-label': 'Conservador' }}
			color="primary"
			/>
			<S.Label htmlFor="investment-1">
				<strong>Conservador</strong>(Poupança, CDB, LCI/LCA e Renda Fixa)
				<span><Link style={{ cursor: 'pointer' }} onClick={onClick}>Rentabilidade real</Link>  <strong>2% ao ano</strong></span>
			</S.Label>
		</S.Control>
		<S.Control>
			<Radio
			name="investment"
			id="investment-2"
			checked={data.investment === 'Moderado'}
			onChange={(e) => {
				setData({
					...data,
					investment: e.target.value
				})
			}}
			value="Moderado"
			inputProps={{ 'aria-label': 'Moderado' }}
			color="primary"
			/>
			<S.Label htmlFor="investment-2">
				<strong>Moderado</strong> (Fundos, títulos de renda fixa e parte em ações)
				<span><Link style={{ cursor: 'pointer' }} onClick={onClick}>Rentabilidade real</Link> <strong>4% ao ano</strong></span>
			</S.Label>
		</S.Control>
		<S.Control>
			<Radio
			name="investment"
			id="investment-3"
			checked={data.investment === 'Agressivo'}
			onChange={(e) => {
				setData({
					...data,
					investment: e.target.value
				})
			}}
			value="Agressivo"
			inputProps={{ 'aria-label': 'Agressivo' }}
			color="primary"
			/>
			<S.Label htmlFor="investment-3">
				<strong>Agressivo</strong> (Boa parte em fundos multimercado, ações e imobiliários)
				<span><Link style={{ cursor: 'pointer' }} onClick={onClick}>Rentabilidade real</Link> <strong>6% ao ano</strong></span>
			</S.Label>
		</S.Control>
	</>)
}
